import React, { useCallback, useState } from 'react'
import { Button, Grid, IconButton, Paper, Stack, Typography } from '@mui/material'
import { useFormContext } from 'react-hook-form'

import { TextFieldControl } from '../form'
import { Icon } from '../icon.tsx'
import { UniqueOfdPosition } from '../refund-sbp-button'
import { formatMoney } from '../../utils.ts'
import Edit from '../../assets/icons/edit.svg?react'

import { OfdPositionDialog } from './ofd-position-dialog.tsx'
import { useUser } from '@/stores/slices/user-slice.ts'

export const OfdFields = (): React.ReactElement | null => {
  const [openPositionDialog, setOpenPositionDialog] = useState(false)
  const [selectedPosition, setSelectedPosition] = useState<UniqueOfdPosition>()
  const user = useUser()
  const { watch, setValue } = useFormContext<{ positions?: Array<UniqueOfdPosition> }>()
  const positions = watch('positions')

  const handleTogglePositionDialog = useCallback(
    (visible: boolean, position?: UniqueOfdPosition) => () => {
      setSelectedPosition(position)
      setOpenPositionDialog(visible)
    },
    []
  )
  const handleRemovePosition = useCallback(
    (id: string) => (event: React.MouseEvent) => {
      event.stopPropagation()
      setValue(
        'positions',
        positions?.filter((position) => position.id !== id)
      )
    },
    [positions]
  )

  if (!user?.permissions.ofd) return null

  return (
    <Grid container flexDirection="row" spacing={2}>
      <Grid item xs={12}>
        <TextFieldControl name="email" fullWidth label="Email клиента для чека" />
      </Grid>
      <Grid item xs={12}>
        {positions?.map((position, idx) => (
          <Paper key={position.id} sx={{ mb: 1, py: 1.5, px: 2 }} elevation={0}>
            <Grid container direction="row" alignItems="center" spacing={2}>
              <Grid item xs={4}>
                <Typography variant="h5">Позиция №{idx + 1}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Stack direction="column">
                  <Typography>{position.text}</Typography>
                  <Typography color="text.secondary">
                    {[position.quantity, position.unitOfMeasurement].join(' ')}
                    {' x '}
                    {formatMoney(position.price)}
                  </Typography>
                </Stack>
              </Grid>
              <Grid container item xs={4} flexDirection="row" justifyContent="flex-end" spacing={2}>
                <Grid item>
                  <IconButton
                    sx={{ width: '50px' }}
                    color="info"
                    size="small"
                    onClick={handleTogglePositionDialog(true, position)}
                  >
                    <Edit />
                  </IconButton>
                </Grid>
                <Grid item>
                  <IconButton
                    sx={{ width: '50px' }}
                    color="error"
                    size="small"
                    onClick={handleRemovePosition(position.id)}
                  >
                    <Icon name="Trash" colorScheme="error.main" />
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        ))}
        <Button startIcon={<Icon name="Add" />} fullWidth onClick={handleTogglePositionDialog(true)} sx={{ mt: 2 }}>
          Добавить позицию для чека
        </Button>
      </Grid>

      <OfdPositionDialog
        open={openPositionDialog}
        position={selectedPosition}
        onClose={handleTogglePositionDialog(false)}
      />
    </Grid>
  )
}
